var collapsibleButtons = document.querySelectorAll('.collapsible__button');

collapsibleButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    var content = button.nextElementSibling;

    if (content.style.display === 'block') {
      content.style.display = 'none';
      content.style.opacity = 0;
      content.style.visibility = 'hidden';
      content.style.height = 0;
      button.classList.remove('collapsible__button-active');
    } else {
      content.style.display = 'block';
      content.style.opacity = 1;
      content.style.visibility = 'visible';
      content.style.height = 'auto';
      button.classList.add('collapsible__button-active');
    }
  });
});
